export default "__VITE_ASSET__DXRP_1EX__"